import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import './style.css';

import P_1 from '../../assets/images/Project1.webp';
import P_2 from '../../assets/images/Project2.webp';
import P_3 from '../../assets/images/Project3.webp';
import P_4 from '../../assets/images/Project4.webp';

import StayConnected from '../../Components/StayConnectedSection';

export default function PressPage() {
  const location = useLocation();
  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

  const pressList = [
    { image: P_2, title: 'Starlife Launches New Luxury Tower' },
    { image: P_3, title: '2025 Market Insights from Starlife' },
    { image: P_4, title: 'New Investment Opportunities Announced' },
  ];

  return (
    <div className='press-single-page'>
      <Helmet>
        <title>Starlife: Press Single Page</title>
        <meta
          name='description'
          content='Stay updated with Starlife Group’s latest news, real estate insights, investment trends, and project announcements.'
        />
        <meta
          name='keywords'
          content='Starlife press, Real estate news, Luxury property updates, Real estate investment insights, Starlife Group announcements, Property market trends'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>
      <div className='col-1'>
        <img src={P_1} alt='press-image' />
        <h2 className='press-page-title'>Press Title</h2>
        <span className='author-name'>Written by Author name</span>
        <div className='press-page-content'>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit.
            Voluptatibus voluptas commodi molestias voluptatum id. Accusamus
            unde reiciendis, doloremque quaerat aliquam, odit nisi nulla sit
            eligendi ad delectus alias debitis distinctio!
          </p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit.
            Voluptatibus voluptas commodi molestias voluptatum id. Accusamus
            unde reiciendis, doloremque quaerat aliquam, odit nisi nulla sit
            eligendi ad delectus alias debitis distinctio!
          </p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit.
            Voluptatibus voluptas commodi molestias voluptatum id. Accusamus
            unde reiciendis, doloremque quaerat aliquam, odit nisi nulla sit
            eligendi ad delectus alias debitis distinctio!
          </p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit.
            Voluptatibus voluptas commodi molestias voluptatum id. Accusamus
            unde reiciendis, doloremque quaerat aliquam, odit nisi nulla sit
            eligendi ad delectus alias debitis distinctio!
          </p>
        </div>
      </div>
      <div className='col-2'>
        <div className='sticky-press-list'>
          <h3>Other Press Articles</h3>
          {pressList.map((item, idx) => (
            <div className='other-press-card' key={idx}>
              <img src={item.image} alt={`press-${idx}`} />
              <p>{item.title}</p>
            </div>
          ))}
          <button className='view-all-press-btn'>View All</button>
        </div>
      </div>
      <StayConnected />
    </div>
  );
}
